<div class="details" *ngIf="game">
  <div
    class="game-banner"
    style="background-image: url({{ game.background_image }})"
  >
    <!-- <img
      src="{{ game.background_image }}"
      alt="background image"
      class="game-banner-img"
    /> -->
  </div>
  <div class="game-content">
    <div class="details-wrapper">
      <div class="game-header">
        <h1 class="game-header-title">{{ game.name }}</h1>
        <h2 class="game-header-release-date">
          Release: {{ game.released | date }}
        </h2>
        <p class="game-header-genres">
          <span *ngFor="let genre of game.genres; let last = last">
            {{ genre.name }}<span *ngIf="!last">,</span>
          </span>
        </p>
        <div class="game-gauge">
          <mwl-gauge
            class="two"
            [max]="100"
            [dialStartAngle]="180"
            [dialEndAngle]="0"
            [value]="gameRating"
            [animated]="true"
            [color]="getColor"
            [animationDuration]="2"
          >
          </mwl-gauge>
          <a
            *ngIf="game.metacritic_url?.length"
            class="game-gauge-label"
            target="_blank"
            href="{{ game.metacritic_url }}"
            >Metacritic
          </a>
          <span class="game-gauge-label" *ngIf="!game.metacritic_url?.length">
            No Metacritic link
          </span>
        </div>
      </div>
      <app-game-tabs [game]="game"></app-game-tabs>
    </div>
  </div>
</div>
